export const isProtectedSuperAdminMember = (member) =>
  String(member?.role || '').toLowerCase() === 'superadmin';
